import { Reservation, bulkAvailableService } from '@lib/state';
import { Badge, Button, ButtonProps } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';

interface Props extends Omit<ButtonProps, 'action' | 'onClick'> {
  propertyId: string;
  corporateAccountId: string;
  selectedReservations: Array<Reservation>;
}

export const BulkCancelButton: React.FC<Props> = ({
  propertyId,
  corporateAccountId,
  selectedReservations,
  ...props
}) => {
  const history = useHistory();
  const targetPage = '/profile/bulk-cancel';

  const handleClick = () => {
    bulkAvailableService.updateUI({
      propertyId,
      corporateAccountId,
      selectedReservations,
    });
    history.push({ pathname: targetPage });
  };

  return (
    <Badge badgeContent={selectedReservations.length} color="error" style={{ marginLeft: '8px' }}>
      <Button type="button" name="bulkCancel" onClick={handleClick} {...props}>
        Cancel
      </Button>
    </Badge>
  );
};
